import { render, staticRenderFns } from "./PatrolRecordDetail.vue?vue&type=template&id=b95ac39e&"
import script from "./PatrolRecordDetail.vue?vue&type=script&lang=js&"
export * from "./PatrolRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./PatrolRecordDetail.vue?vue&type=style&index=0&id=b95ac39e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports